export default "__VITE_ASSET__DrLwnp_D__"